'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormReasonText = function FormReasonText(_ref) {
    var reasonTexts = _ref.reasonTexts;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'col-12' },
            reasonTexts.map(function (text, i) {
                return _react2.default.createElement(
                    'p',
                    { key: i },
                    text
                );
            })
        )
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(FormReasonText);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FormReasonText.js
// module id = 1344
// module chunks = 0